<div class="sign-up">
  <p class="title">Sign Up</p>
  <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
    <mat-form-field class="form-input">
      <mat-label>Full Name</mat-label>
      <input 
        matInput 
        id="name"
        placeholder="Enter Name"
        formControlName="name"
      >
      @if (signupForm.get('name')?.invalid && signupForm.get('name')?.touched) {
        <mat-error>Please enter a valid name</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="form-input">
      <mat-label>Email</mat-label>
      <input 
        matInput 
        id="email"
        placeholder="Enter Email"
        type="email"
        formControlName="email"
      >
      @if (signupForm.get('email')?.invalid && signupForm.get('email')?.touched) {
        <mat-error>Please enter a valid email</mat-error>
      }
    </mat-form-field>

    <div class="password-block">
      <mat-form-field class="form-input">
        <mat-label>Password</mat-label>
        <input 
          matInput 
          id="password"
          [type]="hidePassword() ? 'password' : 'text'"
          placeholder="Enter Password"
          formControlName="password"
          required
          (focus)="showTooltip = true"
          (blur)="showTooltip = false"
          (keypress)="handlePasswordCriteria()"
        >
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="clickPasswordEvent($event)"
          [attr.aria-label]="hidePassword() ? 'Show password' : 'Hide password'"
          [attr.aria-pressed]="hidePassword()"
        >
          <mat-icon>{{hidePassword() ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        @if (
          signupForm.get('password')?.touched && 
          signupForm.get('password')?.hasError('criteriaFailed')) {
          <mat-error>Password not matching the criteria</mat-error>
        } @else if (
          signupForm.get('password')?.invalid && 
          signupForm.get('password')?.touched) {
          <mat-error>Invalid password</mat-error>
        }
      </mat-form-field>
      @if (showTooltip) {
        <app-password-tooltip
          [passCond1]="passCond1"
          [passCond2]="passCond2"
          [passCond3]="passCond3"
          [passCond4]="passCond4"
          [passCond5]="passCond5"
        ></app-password-tooltip>
      }
    </div>

    <mat-form-field class="form-input">
      <mat-label>Confirm Password</mat-label>
      <input 
        matInput 
        id="confirm_password"
        [type]="hideConfirmPassword() ? 'password' : 'text'"
        placeholder="Re-enter Password"
        formControlName="confirm_password"
        required
      >
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="clickConfirmPassEvent($event)"
        [attr.aria-label]="hideConfirmPassword() ? 'Show password' : 'Hide password'"
        [attr.aria-pressed]="hideConfirmPassword()"
      >
        <mat-icon>{{hideConfirmPassword() ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      @if (
        signupForm.get('confirm_password')?.hasError('mismatch') && 
        signupForm.get('confirm_password')?.touched) {
        <mat-error>Passwords does not match</mat-error>
      } @else if (
        signupForm.get('confirm_password')?.invalid && 
        signupForm.get('confirm_password')?.touched) {
        <mat-error>Invalid password</mat-error>
      }
    </mat-form-field>
    
    <div class="form-input accept-checkbox">
      <mat-checkbox  
        id="acceptTerms" 
        formControlName="acceptTerms"
      >
        I agree to the 
      </mat-checkbox>
      <span class="terms-block" (click)="onTermsClick()">Terms and Conditions</span>
      @if (signupForm.get('acceptTerms')?.invalid && signupForm.get('acceptTerms')?.touched) {
        <mat-error>Please accept the T&C</mat-error>
      }
    </div>

    <button 
      mat-flat-button 
      type="submit" 
      class="form-btn"
    >
      Next
    </button>

    <p class="sign-in-text">
      Already have an account? 
      <span class="sign-in-link" (click)="onSignInClick()">Sign In</span>
    </p>
  </form>
</div>
